'use client';
import { Button } from '@curology/ui-components-web/react/Button';
import { Typography } from '@curology/ui-components-web/react/Typography';
import React, { useState } from 'react';

import { useNavigation } from '@/components/flow/hooks/useNavigation';

import ClockIconAndTimeEstimateCopy from './components/clockIconAndTimeEstimateCopy';
import ProviderProfilePicAndExplanatoryText from './components/providerProfilePicAndExplanatoryText';

export const MedicalHistoryIntro = () => {
  const { onNext } = useNavigation();

  const [nextButtonClicked, setNextButtonClicked] = useState(false);

  return (
    <div className="cur-grow cur-m-auto cur-max-w-[407px] cur-px-4 cur-py-8 cur-text-subtle">
      <Typography className="cur-mb-8 cur-text-primary" size="h2">
        Next up: your health info
      </Typography>
      <ProviderProfilePicAndExplanatoryText />
      <ClockIconAndTimeEstimateCopy />
      <div className="cur-mt-8">
        <Button
          className="cur-w-full"
          disabled={nextButtonClicked}
          onClick={() => {
            setNextButtonClicked(true);
            onNext();
          }}
        >
          Get started
        </Button>
      </div>
    </div>
  );
};
